import { LOCATION_CHANGED } from "../actions/locationActions";

// Define the initial state
const initialState = {
  previousLocation: "/",
};

export default function locationReducer(state = initialState, action) {
  switch (action.type) {
    case LOCATION_CHANGED:
      // Return a new state object with the updated previousLocation
      return {
        ...state,  // Spread the existing state to keep other properties unchanged
        previousLocation: action.pathname,  // Update the previousLocation immutably
      };
    default:
      return state;
  }
}